import script from "./ChatWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ChatWindow.vue?vue&type=style&index=0&id=5732d416&scoped=true&lang=css"
import "./ChatWindow.vue?vue&type=style&index=1&id=5732d416&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5732d416"]])

export default __exports__